'use strict';

var AdvancedProfileChart = function AdvancedProfileChart(AbstractProfileChart, chartZoom, chartRectClip, chartVerticalLine, $location) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    var self = this;
    AbstractProfileChart.call(this, container, formatters);
    var params = chartParams(this.axisDirection);
    this.verticalLine = chartVerticalLine('dtd', 'caption').withTextLabelOffsetY(-10);
    var zoom = chartZoom();
    var rectClip = chartRectClip();
    var clipPathId = 'advanced-profile-chart-clip';
    var clipPath = $location.path() + '#' + clipPathId;
    this.render = function (data, range) {
      this.setDataPropertyName('curves');
      this.initChart(data, range, params);
      this.scales = chartScales(this.params, this.data.curves, this.axisDirection);
      this.svg.call(rectClip.id(clipPathId).x(0).y(-this.params.padding.bottom).width(this.container.width() - this.params.padding.right - this.params.padding.left).height(this.container.height()));
      var chartElements = [this.yAxis.withCurveLabel(data.curveLabels), this.curves.clipPath(clipPath), this.verticalLine.withData(data.verticalLine), this.squareIndicators.clipPath(clipPath), this.hoverOver, this.xAxis];
      this.callForDataGroup(chartElements, this.scales);
      var redrawElementsWrapper = function redrawElementsWrapper() {
        var redrawElements = [self.curves, self.squareIndicators, self.xAxis, self.hoverOver, self.verticalLine];
        self.callForDataGroup.call(self, redrawElements);
      };
      this.svg.call(zoom.params(this.params).scales(this.scales).toRedraw([redrawElementsWrapper.bind(this)]));
    };
  };
  Chart.prototype = Object.create(AbstractProfileChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
AdvancedProfileChart.$inject = ['AbstractProfileChart', 'ChartElementsZoom', 'ChartElementsRectClip', 'ChartElementsVerticalLine', '$location'];
module.exports = AdvancedProfileChart;